import { useQuery } from "react-query";
import http from "infra/http";
import { PaginateQuery } from "core/resources/types/shared";
import { PermissaoResponse } from "../typings/types";

function usePermissions(
  params?: PaginateQuery & { origem: string; tenantId?: string },
  cb?: any
) {
  return useQuery("/v1/permissao", async () => {
    const { data } = await http.get<PermissaoResponse[]>("/v1/permissao", {
      params,
      headers: {
        tenant: params?.tenantId,
      },
    });

    cb?.(data);
    return data;
  });
}

export default usePermissions;
